/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Tous
 * 1 = EnAttente
 * 2 = EnDemande
 * 3 = EnCours
 * 4 = Livre
 * 5 = ClotureOuAnnule
 */
export enum DemandeManutentionStatutValuesRequest {
  Tous = 0,
  EnAttente = 1,
  EnDemande = 2,
  EnCours = 3,
  Livre = 4,
  ClotureOuAnnule = 5
}
